import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import styles from './styles';
import data from './hourlyForecastData.json';
import icons from '../../assets/images';
import sampleHourlyForecast from './HourlyForecastDataURI';

class HourlyForecast extends React.PureComponent {
  render() {
    const {
      classes: { container, dayPanel, lastPanel },
    } = this.props;
 
    const HourlyWeatherForecast = unescape(sampleHourlyForecast);
    const HourlyWeatherForecastData = JSON.parse(HourlyWeatherForecast);
    const { HourDetails : hw } = HourlyWeatherForecastData.HourForecasts[0];
    return (
      <React.Fragment>
        <div className={container}>
          <div className={dayPanel}>{this.renderDayPanel(hw[0])}</div>
          <div className={dayPanel}>{this.renderDayPanel(hw[1])}</div>
          <div className={dayPanel}>{this.renderDayPanel(hw[2])}</div>
          <div className={dayPanel}>{this.renderDayPanel(hw[3])}</div>
          <div className={dayPanel}>{this.renderDayPanel(hw[4])}</div>
          <div className={lastPanel}>{this.renderDayPanel(hw[5])}</div>
        </div>
      </React.Fragment>
    );
  }

  /**
   * @name renderCenterPanel
   * @description render the DOM for the Center Panel
   */
  renderDayPanel = hw => {
    const {
      classes: {
        panelContents,
        panelSection,
        panelTitleText,
        tempHigh,
        weatherIcon,
        weatherInfoText,
        precipText,
      },
      t
    } = this.props;
    const weatherImage = `weather${hw.WeatherIcon}`;
    return (
      <React.Fragment>
        <div className={panelSection}>
          <div className={panelContents}>
            <div className={panelTitleText}>{hw.Time}</div>
          </div>
          <div className={panelContents}>
            <div className={weatherIcon}>
            <img alt="weather" src={icons[weatherImage]} />
            </div>
          </div>
          <div className={panelContents}>
            <div>
              <div className={tempHigh}>{hw.Temperature.Value}&#176;</div>
            </div>
          </div>

          <div className={panelContents}>
            <div>
              <div className={precipText}>{`${t('screens.weather.feelslike')} ${hw.FeelsLike.Value}`}&#176;</div>
              <div className={weatherInfoText}>{`${hw.PreciProbability}% ${t('screens.weather.precipitation')}`}</div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
}

HourlyForecast.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(HourlyForecast));
